<template>
  <div id="recycle">
    <div class="box">
      <div v-if="data!=null">
        <div v-for="(item,index) of data" :key="index" class="od-item">
          <div class="od-title">
            <span class="tx1">{{item.date}}</span>
            <span class="tx2">订单编号：{{item.orderCode}}</span>
            <div class="od-menu lv3Text" style="float:right" @click="del(item.id)">删除</div>
          </div>
          <div class="content">
            <div v-for="(item2,index) of productArr[index]" :key="index">
              <el-row v-if="index<3">
                <el-col :span="10">
                  <div class="i1">{{item2.title.substr(0,20)}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="i2">{{item2.item_no}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="i2">x {{item2.number}}</div>
                </el-col>
                <el-col :span="3">
                  <div class="i3">{{item.statusTxt}}</div>
                </el-col>
              </el-row>
              <div v-if="index==3" class="more lv3Text">
                更多
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </div>
          </div>
          <div class="bottom">
            <el-row>
              <el-col :span="15">
                <span>
                  商品件数：
                  <span class="red">{{item.count}} 件</span>
                </span>
                <span>
                  商品总价：
                  <span class="red">&yen; {{item.all_money}}</span>
                </span>
                <span>
                  活动优惠：
                  <span class="red">- &yen; 0</span>
                </span>
                <span>
                  运费：
                  <span class="red">&yen; {{item.express_money}}</span>
                </span>
              </el-col>
              <el-col :span="9" align="right">
                <span class="od-price">
                  应付总额：
                  <span>&yen;{{item.pay_money}}</span>
                </span>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="pager" align="center" v-if="total>0">
          <el-pagination background hide-on-single-page layout="prev, pager, next" :total="total"></el-pagination>
        </div>
      </div>
      <div v-if="empty==true" class="empty" style="padding-bottom:30px;">
        <div style="padding:30px 0">
          <object
            :data="serve + '/images/analyze_report_2.svg'"
            type="image/svg+xml"
            style="width:15%;"
          ></object>
        </div>
        <div style="margin: 10px 0 20px 0;">没有订单</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      //
      data: {},
      productArr: [],
      total: 0,
      empty: false
    };
  },
  created() {
    
    //
    this.$store.state.user_location = "我的订单";
    this.$store.state.leftMenuIndex = 12;
    this.initData();
  },
  methods: {
    //
    del(id) {
      this.axios
        .get(this.serve + "/personal/del_del_order", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "订单已删除",
              center: true
            });
            this.initData();
          }
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/personal/del_order_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: 1
          }
        })
        .then(res => {
          if (res.data.msg == "搜索结果为空") {
            this.data = null;
            this.empty = true;
          } else {
            this.data = res.data.data.results;
            this.total = res.data.data.total;
            this.counts = res.data.data.counts;
            for (var item of this.data) {
              var l = this.productArr.length;
              var listObj = JSON.parse(item["product_list"]);
              this.productArr[l] = listObj;
              var res = this.dayjs
                .unix(item["create_time"])
                .format("YYYY-MM-DD HH:mm:ss");
              item["date"] = res;
              var totalNumber = 0;
              if (listObj) {
                for (var item2 of listObj) {
                  totalNumber += parseFloat(item2.number);
                }
              }
              item["count"] = totalNumber;
              item["statusTxt"] = "已删除";
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
#recycle {
  
  .empty {
    padding: 20px 0;
  }
  .od-menu:hover {
    text-decoration: underline;
  }
  .od-menu {
    cursor: pointer;
  }
  .i1 {
    color: #333;
    padding: 0 20px;
    line-height: 70px;
  }
  .i2 {
    color: #666;
    line-height: 70px;
  }
  .i3 {
    color: #e2211c;
    line-height: 70px;
  }
  .content .el-row {
    border-bottom: 1px solid #ddd;
  }
  .od-title {
    background-color: #f5faf9;
    padding: 15px;
    border-bottom: 1px solid #ddd;
    font-size: 12px;
    .tx1 {
      color: #666666;
      margin-right: 10px;
    }
    .tx2 {
      color: #333333;
    }
  }
  .od-item {
    margin: 10px;
    border: 1px solid #ddd;
    margin-bottom: 20px;
    .bottom {
      padding: 20px;
    }
  }
  .box {
    background-color: #fff;
    padding: 20px;
    min-height: 600px;
  }
}
</style>